import WaterImage from './WaterImage';

export default WaterImage;